import { onAuthStateChanged, User } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth, db, signOut } from "../services/firebase";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { serverUrl } from "../constants";
import { UserDb } from "../models/user.db";

export default function useAuth() {
  const [fbUser, setFbUser] = useState<undefined | User | null>(undefined);
  const [userId, setUserId] = useState<string>("");
  const [indyxUser, setIndyxUser] = useState<UserDb | null>(null);

  useEffect(() => {
    onAuthStateChanged(auth, (u) => {
      setFbUser(u);
    });
  }, []);

  useEffect(() => {
    if (!fbUser) {
      return;
    }
    const getClaims = async (forceRefresh: boolean) => {
      if (userId !== "") return;
      if (forceRefresh) {
        const token = await fbUser.getIdToken(forceRefresh);
        await fetch(`${serverUrl}/auth/checkClaims`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({}),
        });
      }
      const tokenResult = await fbUser.getIdTokenResult(forceRefresh);
      if (tokenResult == null) {
        return;
      }
      const uId = (tokenResult.claims["userId"] ?? "") as string;
      if (uId !== "") {
        setUserId(uId);
        console.log("userId", uId);
      } else {
        if (!forceRefresh) {
          getClaims(true);
        }
      }
    };
    getClaims(false);
  }, [fbUser, userId]);

  useEffect(() => {
    if (userId === "") {
      return;
    }
    const userDocRef = doc(db, "users", userId);
    const unsubscribe = onSnapshot(
      userDocRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const user = docSnap.data() as UserDb;
          setIndyxUser(user);
        } else {
          console.log("User not found");
        }
      },
      (error) => {
        console.error("Error fetching user:", error);
      }
    );
    return unsubscribe;
  }, [userId]);

  const logOut = async () => {
    await signOut();
    setFbUser(null);
    setUserId("");
    setIndyxUser(null);
  };

  const updateUser = async (upd: Partial<UserDb>) => {
    if (!userId) {
      return;
    }
    const ts = Date.now();
    upd.updatedAt = ts;
    const userDocRef = doc(db, "users", userId);
    await updateDoc(userDocRef, upd);
  };

  return {
    fbUser,
    indyxUser,
    userId,
    logOut,
    updateUser,
  };
}
